import Grid from '@material-ui/core/Grid';
import React from 'react';
import { FormattedNumber } from 'react-intl';
import { useObservable } from 'react-use-observable';
import newRefundService from 'v2/services/new-refund-service';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import type { NewRefundServicePermission } from 'v2/services/new-refund-service';

import BankSlipInstallment from './bankSlipIntallment';
import { BuyerDetails } from './buyerDetails';
import FiscalDocument from './fiscalDocument';
import InvoiceDetail from './invoiceDetails';
import RefundActions from './refundActions';
import useStyle from '../styles';

const PhysicalProduct = ({ delivery }: { delivery: ShoppingDelivery }) => {
  const classes = useStyle();
  const [user] = useObservable<NewRefundServicePermission>(
    () => newRefundService.getPermissionToNewRefundServiceByInvoiceId(delivery.invoice_id.toString()),
    []
  );

  const hasPermissionToUseNewRefundService = user && user.success && user.data.producer_can_access;

  return (
    <>
      <div className={classes.quickviewDataBasic}>
        <Grid container spacing={2}>
          <>
            <Grid item md={4} sm={12} xs={12}>
              <div className='image' style={{ backgroundImage: `url(${delivery.product.image})` }}></div>
            </Grid>

            <Grid item md={8} sm={12} xs={12}>
              <div className='info'>
                <h2>
                  {delivery.product.title}
                  {delivery.order.status && <span className='status'>{delivery.order.status}</span>}
                </h2>

                <div className='tracking'>
                  {delivery.order.tracker_code ? (
                    <div className='data'>
                      Rastreio: <span>{delivery.order.tracker_code}</span>
                    </div>
                  ) : (
                    ''
                  )}
                  {delivery.freight_value ? (
                    <div className='data'>
                      Frete pago:{' '}
                      <span>
                        <FormattedNumber value={delivery.freight_value} format='BRL' />
                      </span>
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </Grid>
          </>
        </Grid>
      </div>

      <div className='m24'></div>

      <BuyerDetails delivery={delivery} />

      <div className='m24'></div>

      <div className={classes.sender}>
        <h3>Dados do remetente</h3>
        {delivery.producer.name && (
          <div className='data'>
            <span>Nome:</span> {delivery.producer.name}
          </div>
        )}
        {delivery.producer.email && (
          <div className='data'>
            <span>E-mail:</span> {delivery.producer.email}
          </div>
        )}
        {delivery.producer.phone && (
          <div className='data'>
            <span>Telefone:</span> {delivery.producer.phone}
          </div>
        )}
        {delivery.producer.address && (
          <div className='data'>
            <span>Endereço:</span> {delivery.producer.address}
          </div>
        )}
      </div>

      <div className='m24'></div>

      {!delivery.bankslip_installments && (
        <>
          <InvoiceDetail delivery={delivery} />
          <div className='m8'></div>
        </>
      )}

      {!delivery.unlimited_installment && delivery?.bankslip_installments && (
        <>
          <div className='m24' />
          <BankSlipInstallment delivery={delivery} />
        </>
      )}

      <div className='m8'></div>

      {hasPermissionToUseNewRefundService && <RefundActions delivery={delivery} />}

      <div className='m8'></div>

      <FiscalDocument delivery={delivery} />
    </>
  );
};

export default PhysicalProduct;
